<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{
          localAula.tipo_de_aula
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Professor (a)</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.professor?.nome }}
        </p>
        <v-divider></v-divider>
        <v-list-item-title>Data</v-list-item-title>
        <p v-if="!localAula.is_polivalencia" class="font-weight-light text-justify">
          {{ localAula.data_formatada }}
          {{ " - " }}
          {{ localAula.horario ? localAula.horario.descricao : "[- - -]" }}
        </p>
        <p v-else class="font-weight-light text-justify">
          {{ localAula.data_formatada }}
          {{ " - " }}
          {{ localAula.horarios_formatted ? localAula.horarios_formatted : "[- - -]" }}
        </p>
        <template v-if="localAula.disciplina">
          <div class="mt-4 mb-0">
            <v-list-item-title>
              <strong> Componente Curricular:</strong>
              {{ localAula.disciplina ? localAula.disciplina.descricao : "[- - -]" }}
            </v-list-item-title>
          </div>
        </template>
        <template v-else>
          <div class="mt-4 mb-5">
            <v-list-item-title>Componente(s) Curricular(es)</v-list-item-title>
          </div>
          <div class="mt-n5" v-if="localAula.is_polivalencia == 1">
            <div>
              <div v-for="(item, index) in localAula.polivalencia_formatted" :key="index">
                <v-card elevation="0" class="pa-1 mt-1" style="border: 1px solid #cfd8dc">
                  <div class="pa-2">
                    <span class="font-weight-bold text-uppercase">
                      {{ item.disciplina.descricao ?? "- - -" }}
                    </span>
                    <div class="mt-2">
                      <span>Conteúdo: </span>
                      <div style="border: 1px solid #cfd8dc; border-radius: 4px">
                        <span class="font-weight-light text-justify" v-if="item.conteudo">
                          <div class="ml-4 mb-4 mt-2 mr-2">{{ item.conteudo }}</div>
                        </span>
                      </div>
                    </div>
                    <div class="mt-2">
                      <span>Horário: </span>
                      <div>
                        <span class="font-weight-light text-justify" v-if="item.conteudo">
                          <div class="ml-4 mb-4">
                            <ul v-for="(horario, index) in item.horarios" :key="index">
                              <li>{{ horario.descricao }}</li>
                            </ul>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>
          <div v-if="localAula.is_polivalencia != 1">
            <div v-for="(disciplina, index) in localAula.disciplinas_com_descricao" :key="index">
              <span class="font-weight-bold text-uppercase">{{
                disciplina.descricao ? disciplina.descricao : "- - -"
              }}</span>
              <br />
              <br />
              <span>Conteúdo: </span>
              <br />
              <div class="ml-4 mb-4">
                <!-- Renderiza conteudo_polivalencia com v-html -->
                <span
                  v-if="localAula.conteudo_polivalencia"
                  v-html="
                    JSON.parse(localAula.conteudo_polivalencia)[index]
                      ? JSON.parse(localAula.conteudo_polivalencia)[index].replace(/:\s*$/, '') +
                        '.'
                      : '- - -'
                  "
                  class="font-weight-light text-justify"
                ></span>
              </div>
            </div>
          </div>
        </template>
        <div v-for="(item, index) of $constants.listCamposAulasLancadas" :key="index">
          <div v-if="index !== 'campos_de_experiencias'">
            <v-list-item-title v-if="localAula[index]" class="mt-4 mb-5">
              {{ item }}
            </v-list-item-title>
            <div v-if="localAula[index]" class="font-weight-light text-justify">
              <div
                v-html="formatTexto(localAula[index]) ? formatTexto(localAula[index]) : '- - -'"
              ></div>
            </div>
          </div>
          <div v-else>
            <div v-if="localAula.e_aula_infantil == 1">
              <v-list-item-title v-if="localAula[index]" class="mt-4 mb-2">
                {{ item }}
              </v-list-item-title>
              <div v-for="(el, index) of localAula[index]" :key="index">
                <p v-if="el" :key="index" class="font-weight-light text-justify">•{{ el }}</p>
              </div>
            </div>
          </div>
        </div>
        <v-divider></v-divider>
        <!-- <v-list-item-title class="mt-4">Metodología</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.metodologia }}
        </p> -->
        <v-divider></v-divider>
        <v-list-item-title class="mt-4">Situação</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="localAula.color">
            {{ localAula.descricaoSituacao }}
          </v-chip>
        </v-list-item-title>
        <v-list-item-title class="mt-4">Motivo</v-list-item-title>
        <p class="font-weight-light">
          {{ localAula.motivo ? localAula.motivo : "Sem motivo." }}
        </p>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    aula: {
      type: Object,
      required: true,
    },
    disciplina: {
      type: Object,
      required: false,
    },
  },
  methods: {
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, ""); // Remover colchetes
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, ""); // Remover caracteres de nova linha (\n) e aspas
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>"); // Substituir quebras de linha por HTML <br>
      return textoFormatado.trim() || "- - -";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  computed: {
    localAula() {
      return this.aula;
    },
  },
  data() {
    return {
      localDrawer: this.value,
    };
  },
};
</script>

<style lang="scss" scoped></style>
